if (typeof Array.prototype.at !== 'function') {
  // eslint-disable-next-line no-extend-native
  Array.prototype.at = function at(index) {
    const length = this.length;
    const n = Number(index);
    const k = n !== n || n === Infinity || n === -Infinity ? 0 : Math.trunc(n);
    const relativeIndex = k >= 0 ? k : length + k;
    if (relativeIndex < 0 || relativeIndex >= length) {
      return undefined;
    }
    return this[relativeIndex];
  };
}